// Felles tekster og hjelpere for sykkelhotellet i ansatt-appen (se sykkelhotell-plan.md).
export const STATUS_LABEL = {
  innlevert: "Innlevert, venter på transport",
  lagret: "På lageret",
  "henting-bestilt": "Henting bestilt",
  klar: "Klar til henting",
  utlevert: "Utlevert",
};
export const STATUS_KORT = {
  innlevert: "Innlevert",
  lagret: "På lageret",
  "henting-bestilt": "Henting bestilt",
  klar: "Klar til henting",
  utlevert: "Utlevert",
};
export const STATUS_CLS = {
  innlevert: "bg-amber-100 text-amber-900",
  lagret: "bg-green-100 text-green-800",
  "henting-bestilt": "bg-sky-100 text-sky-900",
  klar: "bg-indigo-100 text-indigo-900",
  utlevert: "bg-gray-200 text-gray-700",
};
export const HENDELSE_LABEL = {
  inn: "Levert inn",
  "til-lageret": "Fraktet til lageret",
  "henting-bestilt": "Henting bestilt",
  klar: "Klar til henting",
  ut: "Utlevert",
  endret: "Endret",
};

// Samme liste som STEDER i src/model/Sykkelhotell.js. Lageret er ikke et hentested.
export const STED_LABEL = {
  "sport1-royken": "Sport 1 Røyken",
  "sport1-slemmestad": "Sport 1 Slemmestad",
  verksted: "Verkstedet",
};

export const VARSEL_VIRKEDAGER = 3;

// Spørsmålet kunden får når sykkelen legges inn. Samme tekst som
// «sykkelhotell-sms-v1» i src/samtykke/tekster.js; endres den, lag en ny versjon der.
export const SESONG_SMS_SPORSMAL =
  "Vil du ha SMS fra oss om høsten når sykkelhotellet tar imot sykler igjen? " +
  "Du kan ombestemme deg når som helst.";

export function sykkelTekst(post) {
  if (post?.bikeId && typeof post.bikeId === "object") {
    return [post.bikeId.merke, post.bikeId.modell].filter(Boolean).join(" ") || post.sykkel || "";
  }
  return post?.sykkel || "";
}
